import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-change-propertyform',
  templateUrl: './change-propertyform.component.html',
  styleUrls: ['./change-propertyform.component.css']
})
export class ChangePropertyformComponent implements OnInit {
  title="Change Property Quota"
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/allocation/change-property/change-propertyform/change-propertyform.component.ts